import React from 'react';

const WhyChoose = () => {
  const features = [
    {
      title: "Commercial-Grade Lights",
      description: "Last longer, brighter, safe for Canadian winters"
    },
    {
      title: "Full Service",
      description: "Design → Install → Maintain → Take Down"
    },
    {
      title: "Local Experts",
      description: "Serving Barrie, Collingwood, Orillia & area"
    },
    {
      title: "Safe & Insured",
      description: "Working-at-heights trained & fully insured team"
    }
  ];

  return (
    <section className="py-8 bg-gradient-to-br from-red-50 to-green-50">
      <div className="container mx-auto px-6">
        <h2 className="dest_heading mb-12">Why Choose Prime Christmas Lighting</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-2">
              <h3 className="text-xl font-bold text-red-700 mb-4">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;